import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconCoin2: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 12.68C3.77 13.412 4.81102 14.035 6.05402 14.499C6.17002 14.542 6.25 14.652 6.25 14.776V17.693C6.25 17.907 6.02699 18.058 5.83099 17.973C4.08499 17.222 3 16.059 3 14.5V12.68ZM11.25 15.763V18.665C11.25 18.836 11.104 18.976 10.933 18.969C9.88298 18.928 8.887 18.81 7.987 18.621C7.847 18.592 7.75 18.466 7.75 18.323V15.39C7.75 15.199 7.92097 15.061 8.10797 15.101C8.99697 15.294 9.95699 15.42 10.964 15.467C11.123 15.476 11.25 15.604 11.25 15.763ZM16.25 15.391V18.324C16.25 18.467 16.154 18.593 16.013 18.622C15.112 18.811 14.116 18.929 13.067 18.97C12.896 18.977 12.75 18.837 12.75 18.666V15.764C12.75 15.605 12.877 15.477 13.036 15.469C14.044 15.422 15.003 15.296 15.892 15.103C16.079 15.062 16.25 15.2 16.25 15.391ZM21 12.68V14.5C21 16.059 19.915 17.222 18.169 17.973C17.973 18.057 17.75 17.906 17.75 17.693V14.776C17.75 14.652 17.83 14.542 17.946 14.499C19.189 14.035 20.23 13.412 21 12.68ZM3 9.5C3 11.985 7.029 14 12 14C16.971 14 21 11.985 21 9.5C21 7.015 16.971 5 12 5C7.029 5 3 7.015 3 9.5Z" fill={color} />
  </svg>
);

export default IconCoin2;
